import { dashboardApi, type DashboardDto } from '../../services/api';
import { onLocaleChange } from '../../services/i18n';
import { esc } from './dashboard-shared';
import './rc-dashboard-view';
import { RcDashboardView } from './rc-dashboard-view';

export class RcDashboard extends HTMLElement {
  private data: DashboardDto | null = null;
  private disposeLocaleChange?: () => void;

  async connectedCallback(): Promise<void> {
    this.innerHTML = `<div class="stats-grid">${[1, 2, 3].map(() => `<div class="stat-card skeleton-card"></div>`).join('')}</div>`;
    this.disposeLocaleChange = onLocaleChange(() => this.render());
    try {
      this.data = await dashboardApi.get();
      this.render();
    } catch (error: any) {
      this.innerHTML = `<div class="empty-state">Fout bij het laden van het dashboard: ${esc(error.message)}</div>`;
    }
  }

  disconnectedCallback(): void {
    this.disposeLocaleChange?.();
  }

  private render(): void {
    if (!this.data) {
      if (this.isConnected) {
        this.innerHTML = `<div class="stats-grid">${[1, 2, 3].map(() => `<div class="stat-card skeleton-card"></div>`).join('')}</div>`;
      }
      return;
    }
    this.innerHTML = '<rc-dashboard-view></rc-dashboard-view>';
    const view = this.querySelector('rc-dashboard-view') as RcDashboardView | null;
    if (!view) return;
    view.data = this.data;
    view.render();
  }
}

if (!customElements.get('rc-dashboard')) {
  customElements.define('rc-dashboard', RcDashboard);
}
